import * as Yup from 'yup';

const address1 = Yup.string().when('isRm', {
  is: true,
  then: Yup.string().required('Street address is required'),
});

export default address1;
